export default "__VITE_ASSET__Ccu_pD3R__"